console.log('components/modal.js v0.0.2');

const modals = (() => {
	return {
    /**
     * Creates modal instance 
     * @param {String} title of the modal
     * @param {String} the whole body of the modal
     * @param {String} actions for the footer of the modal (buttons etc)
     * @param {String} align - alignment of the modal
     * @param {Boolean} hasHeaderImage - modal has header image
     * @param {String} headerImageUrl - header image url
     * @param {String} type - type of modal eg marketing etc
     */

		create: (title, body, actions, align = "", hasHeaderImage = false, headerImageUrl = "", type = "", customStyle = "") => {
			modals.createOverlay();

			document.body.style.overflowY = 'hidden';

			let modalAlignClass = "";
			if(align != "") {
				modalAlignClass = `adaptive-modal--${align}`;	
			}
			
			const modal = `
				<div id="modal" class="adaptive-modal shadow--large ${modalAlignClass} ${type} ${customStyle}" role="modal" aria-hidden="false">
					${modals.createHeader(title, hasHeaderImage, headerImageUrl)}
					${modals.createBody(body)}
					${modals.createFooter(actions)}
				</div>
			`;

			document.body.insertAdjacentHTML('beforeend', modal);
			document.addEventListener('keyup', modals.handleEscape);
		},

    /**
     * Create the adaptive modal overlay which is shown behind the modal
     */

		createOverlay: () => {
			const background = `<div class="modal-backdrop-light in"></div>`;
			document.body.insertAdjacentHTML('beforeend', background);
		},
	/**
	 * create the header element of the modal
	 * @param {String} title - the title of the modal
	 * @param {Boolean} hasHeaderImage - modal has header image
	 * @param {String} headerImageUrl - header image url
	 */
		createHeader: (title, hasHeaderImage, headerImageUrl) => {
			let header = '';
			let closeSvg = '';
			let headerClass = '';
			if(title != '') {
				headerClass = 'has-title';
			}
			if(hasHeaderImage) {
				closeSvg = `
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
						<path d="M12.3331 1.6667L1.66641 12.3334" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M12.3331 12.3334L1.66641 1.6667" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				`;
			}
			else {
				closeSvg = `
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
						<path d="M16 1.61714L14.3829 0L8 6.38286L1.61714 0L0 1.61714L6.38286 8L0 14.3829L1.61714 16L8 9.61714L14.3829 16L16 14.3829L9.61714 8L16 1.61714Z" fill="black"/>
					</svg>
				`;	
			}

			let actionRight = `
				<div class="action-right">
					<button class="close" aria-label="close" data-dismiss="modal">
						<span aria-hidden="true">
              ${closeSvg}	
						</span>
					</button>
				</div>
			`;

			if(hasHeaderImage) {
				header = `
					<header class="header-image-container">
						<img src="${headerImageUrl}" class="header-image"/>
						${actionRight}
					</header>
				`;
			}
			else {
				header = `
					<header class="${headerClass}">
						<div class="action-left">&nbsp;</div>
						<h2 class="title">${title}</h2>
						${actionRight}
					</header>
				`;
			}

			return header;
		},
    /**
     * create the footer element of the modal
     * @param {String} actions - the actions that can be shown in the footer 
     */
		createFooter: (actions = "") => {
			if (actions != "") {
				const footer = `
					<footer>
						${actions}
					</footer>
				`;

				return footer;
			}
			return "";
		},

    /**
     * create the body element of the modal
     * @param {String} content - all the content that will be shown in the main element of the modal 
     */

		createBody: (content) => {
			const body = `
				<main class="adaptive-modal-content">
					${content}
				</main>
			`;

			return body;
		},
    
    /**
     * alternative to modals.create method 
     */

		open: () => {
			modals.create();
		},
    /**
     * modals.close method
     * closes the current modal
     */
		close: () => {
			const currentModal = document.querySelector('.modal');
			currentModal.classList.add('hidden');
		},

    /**
     * destroy the modal
     * @param {String} target (html element) - the modal to destroy
     */

		destroy: (target) => {
			var currentModal;
			var overlay = document.querySelector('.modal-backdrop-light');

			if(target) {
				target.classList.contains('modal-backdrop-light') ? currentModal = target.nextElementSibling : currentModal = target.closest('.adaptive-modal');
			}
			else {
				currentModal = overlay.nextElementSibling;
			}

			if (currentModal !== null && overlay !== null) {
				currentModal.remove();
				overlay.remove();
			}

			document.body.style.overflowY = 'auto';
		},

    /**
     * handleEscape - close the modal when pressing the escape key
     * @param {Event} 
     */
		handleEscape: (event) => {
			if (event.key == 'Escape') {
				modals.destroy();
			}
		},
		load: () => {

		}
	}
})();
